<template>
  <div class="w-[280px] h-[240px] flex items-center justify-center relative">
    <Icon v-if="iconComponent" :icon="iconComponent" class="w-full h-full" />
    <slot v-else />
  </div>
</template>

<script setup lang="ts">
import { computed, type Component } from 'vue';
import { Icon } from '@/components/base/icon';
import { IllustrationVariant } from './state-container.constants';
import Error500Svg from '@/assets/icons/error/500.svg?component';
import Error404Svg from '@/assets/icons/error/404.svg?component';

type Props = {
  illustration?: IllustrationVariant;
};
const props = defineProps<Props>();

const registry: Record<IllustrationVariant, Component> = {
  [IllustrationVariant.HTTP_500]: Error500Svg,
  [IllustrationVariant.HTTP_404]: Error404Svg,
};

const iconComponent = computed<Component | undefined>(() =>
  props.illustration ? registry[props.illustration] : undefined,
);
</script>
